// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import Loading from 'Admin/Component/Loading';
import { ApprHistoryApi, ReviewAprvSelfApi } from '_Route/Api';
import ReceiptPopUp from 'Admin/Component/ReceiptPopUp';


const AdDashboard = () => {

  const sessionID = localStorage.getItem('memSessionID')
  const userUid = useSelector(state => state.authorityAcc.uid);
  const userName = useSelector(state => state.authorityAcc.name);

  const [loading, setLoading] = useState(false)
  const [popUpState, setPopUpState] = useState(false)
  const [aprvData, setAprvData] = useState([])
  const [curAprvData, setCurAprvData] = useState([]);
  const [myAprvData, setMyAprvData] = useState({
    progress: [],
    specifier: [],
    approver: [],
    complete: [],
  })
  const [myAppr, setMyAppr] = useState({ // 로그인된 유저의 검토/승인자 포함 정보 
    specifier: '',
    approver: '',
  }) 

  /* ========================================================================
  * Axios History
  ========================================================================*/
  useEffect(() => {
    // 전체 검토/승인 요청 목록 조회
    setLoading(false)
    axios({
      url: ApprHistoryApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log("GET Approver History List Success", res);
      const r = res.data.result
      setAprvData(r.filter(key => Number(key.approve_status_int) !== 3))

      const progressData = r.filter(key => key.approve_req === userName && Number(key.approve_status_int) !== 3)
      const specData = r.filter(key => key.approve_req === userName && Number(key.approve_status_int) === 1)
      const apprData = r.filter(key => key.approve_req === userName && Number(key.approve_status_int) === 2)
      const completeData = r.filter(key => key.approve_req === userName && Number(key.approve_status_int) === 3)
      setMyAprvData({
        ...myAprvData,
        progress: progressData,
        specifier: specData,
        approver: apprData,
        complete: completeData,
      })
    })
    .catch(err => {
      console.error("GET Approver History List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })

    // 나의 검토/승인자 목록 조회
    axios({
      url: ReviewAprvSelfApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        uid: userUid
      }
    })
    .then(res => {
      // console.log(res, "Reviewer / Applover Self List GET Success!")
      const r = res.data.result

      setMyAppr({...myAppr, specifier: r.specifier[0], approver: r.approver[0]})
    })
    .catch(err => { 
      console.error(err, "Reviewer / Applover Self List GET Error...")
    })
  }, [])


  return (
    <>
      <div className="adContTitGroup">
        <h2>Dashboard</h2>
        <p>Home / Dashboard</p>
      </div>

      <div className="dashboardArea">

        <div className="adItmBox box1">
          <div className="titGrp">
            <h2>내 검토/승인</h2>
            <p className="sub">요청 요약</p>

            <Link to="/admin/review-aprv/appt">변경하기 <i className="icofont-rounded-right" /></Link>
          </div>

          <div className="innerBox">
            <div className="titGrp col">
              <div className="inner">
                <h3>나의 검토자</h3>
                <p>
                  {myAppr.specifier ? myAppr.specifier.acc_name : '지정된 나의 검토자가 없습니다.'}
                  {myAppr.specifier && <span className="sub"> ({myAppr.specifier.acc_email})</span>}
                </p>
              </div>

              <div className="inner">
                <h3>나의 승인자</h3>
                <p>
                  {myAppr.approver ? myAppr.approver.acc_name : '지정된 나의 승인자가 없습니다.'}
                  {myAppr.approver && <span className="sub"> ({myAppr.approver.acc_email})</span>}
                </p>
              </div>
            </div>
          </div>
          
          <div className="innerBox total">
            <div className="totalItm">
              <i className="icofont-paper" />
              <strong>{myAprvData.progress.length.toLocaleString()}</strong>
              <span>요청 진행건 수</span>

            </div>
            <div className="totalItm review">
              <i className="icofont-pen-alt-4" />
              <strong>{myAprvData.specifier.length.toLocaleString()}</strong> 
              <span>검토 완료 건수</span>
              
            </div>
            <div className="totalItm appr">
              <i className="icofont-quill-pen" />
              <strong>{myAprvData.approver.length.toLocaleString()}</strong>
              <span>승인 완료 건수</span>
            </div>
            <div className="totalItm complete">
              <i className="icofont-ui-check" />
              <strong>{myAprvData.complete.length.toLocaleString()}</strong>
              <span>반영 완료 건수</span>
            </div>
          </div>
        </div>

        <div className="adItmBox box2">
          <div className="titGrp">
            <h2>진행중인 요청 사항</h2>
            <p className="sub">아직 반영 완료되지 않은 최근 검토/승인 요청을 보여줍니다.</p>
          </div>
          
          <div className="innerBox">
            {aprvData.length > 0 ?
              <div className="table board">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>요청 유형</th>
                      <th>요청자</th>
                      <th>처리상태</th>
                      <th>요청일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {aprvData.map((data, i) => 
                      <tr key={i}>
                        <td>{`${i < 9 ? '0' : ''}${i + 1}`}</td>
                        <td><button type="button" style={{textDecoration: 'underline'}} onClick={() => {setPopUpState(true); setCurAprvData(data)}}>{data.approve_req_cat}</button></td>
                        <td>{data.approve_req}</td>
                        <td className={`status_${data.approve_status_int}`}>{data.approve_status}</td>
                        <td>{moment(data.approve_req_date).format('YYYY-MM-DD HH:mm')}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              :
              <div className="noData">
                <i className="icofont-warning-alt"></i>
                <p>진행중인 요청건이 없습니다.</p>
              </div>
            }
          </div>
        </div>
      </div>

      {/* 요청 유형 팝업 */}
      <ReceiptPopUp
        popUpState={popUpState}
        setPopUpState={setPopUpState}
        curData={curAprvData}
      />
    </>
  )
}

export default AdDashboard;